
import React from 'react';
import { Link } from 'react-router-dom';

type FooterLinkProps = {
  href: string;
  children: React.ReactNode;
  isRouterLink?: boolean;
};

const FooterLink = ({ href, children, isRouterLink = false }: FooterLinkProps) => {
  const linkStyles = "text-sm text-gray-600 transition-colors hover:text-indigo-600";

  return (
    <li>
      {isRouterLink ? (
        <Link to={href} className={linkStyles}>
          {children}
        </Link>
      ) : (
        <a href={href} className={linkStyles}>
          {children}
        </a>
      )}
    </li>
  );
};

export default FooterLink;
